import ExecutiveKPIs from "../overview/ExecutiveKPIs";
import ConversionFunnel from "../overview/ConversionFunnel";
import PaymentHealth from "../overview/PaymentHealth";
import WebsiteStats from "../overview/WebsiteStats";
import { exportAnalyticsDashboard } from "../../../services/api";
import ExportButtons from "../../ExportButtons";
import { handleExportResponse } from "../../../utils/exportUtils";
const OverviewTab = ({ dashboard }) => {
    if (!dashboard) return null;

    const handleExport = async (format) => {
        try {
            const response = await exportAnalyticsDashboard(format);

            handleExportResponse(
                response,
                format,
                `analytics-overview.${format}`
            );
        } catch (e) {
            console.error(e);
        }
    };

    return (
        <div className="space-y-5">
            <ExportButtons onExport={handleExport} isLoading={false} />
            <ExecutiveKPIs dashboard={dashboard} />
            <ConversionFunnel dashboard={dashboard} />
            <div className="grid grid-cols-1 gap-4 xl:grid-cols-5">
                <div className="xl:col-span-2">
                    <PaymentHealth paymentHealth={dashboard.payment_health} />
                </div>
                <div className="xl:col-span-3">
                    <WebsiteStats dashboard={dashboard} />
                </div>
            </div>
        </div>
    );
};

export default OverviewTab;